import React from 'react';

interface BlockInverterDrilldownProps {
  blockId: string;
  inverterId: string;
  power: number;
  onClose: () => void;
}

const BlockInverterDrilldown: React.FC<BlockInverterDrilldownProps> = ({
  blockId,
  inverterId,
  power,
  onClose
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Inverter Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-600">Block ID:</span>
            <span className="font-medium">{blockId}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Inverter ID:</span>
            <span className="font-medium">{inverterId}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Active Power:</span>
            <span className="font-medium text-blue-600">{power.toFixed(2)} kW</span>
          </div>
          
          <div className="pt-4 border-t">
            <div className="text-sm text-gray-500 mb-2">Performance Status:</div>
            <div className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
              power > 60 ? 'bg-green-100 text-green-800' :
              power > 40 ? 'bg-yellow-100 text-yellow-800' :
              power > 20 ? 'bg-orange-100 text-orange-800' :
              'bg-red-100 text-red-800'
            }`}>
              {power > 60 ? 'Excellent' :
               power > 40 ? 'Good' :
               power > 20 ? 'Fair' : 'Poor'}
            </div>
          </div>
        </div>
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockInverterDrilldown;